import React from 'react';
import { Grid, ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import InputProps from '../InputProps';
import BaseInputWrapper from '../BaseInputWrapper';
import colors from '../../../theme/colors';
import { generateProperties, ButtonGroupElements } from '../helpers';

const useStyles = makeStyles({
  buttonWrapper: {
    marginTop: 24,
  },
  buttonElement: {
    padding: '7px 10px',
    borderRadius: 4,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: colors.silver,
    backgroundColor: colors.white,
    marginRight: 8,
    marginBottom: 8,
  },
  selectedElement: {
    backgroundColor: 'rgba(67, 221, 151, 0.29)',
    borderColor: colors.shamrock,
  },
});

export interface ButtonGroupProps extends InputProps<string> {
  buttons: ButtonGroupElements;
}

const ButtonGroup = ({
  inputId,
  inputName,
  inputLabel,
  onChange,
  buttons,
  defaultValue = '',
  inputError = false,
  inputErrorMessage = '',
  isDisabled = false,
  dataSource,
}: ButtonGroupProps): JSX.Element => {
  const formInputProps = generateProperties<string>({
    inputName,
    onChange,
    defaultValue,
    inputError,
    inputErrorMessage,
    dataSource,
  });

  const classes = useStyles();
  return (
    <BaseInputWrapper
      inputId={inputId}
      label={inputLabel}
      error={formInputProps.error}
      errorMessage={formInputProps.errorText}
      disabled={isDisabled}
    >
      <Grid
        direction="row"
        container
        alignItems="center"
        className={classes.buttonWrapper}
      >
        {Object.keys(buttons).map(
          (buttonKey: string): React.ReactNode => (
            <ButtonBase
              id={`${inputId}-${buttonKey}`}
              key={buttonKey}
              data-testid={buttonKey}
              disabled={isDisabled}
              className={clsx(
                classes.buttonElement,
                buttonKey === formInputProps.value
                  ? classes.selectedElement
                  : '',
              )}
              onClick={(): void => formInputProps.onChange(buttonKey)}
            >
              {buttons[buttonKey]}
            </ButtonBase>
          ),
        )}
      </Grid>
    </BaseInputWrapper>
  );
};

export default ButtonGroup;
